// extracted by mini-css-extract-plugin
module.exports = {"noiseOverlay":"Noise_noiseOverlay__oQ6nM"};